var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHostStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1298_209)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1828 3.75741L12.0718 2.64649C11.4861 2.06071 10.5363 2.06071 9.95053 2.64649L8.83961 3.75741H7.26854C6.44012 3.75741 5.76854 4.42898 5.76854 5.25741V6.82847L4.65763 7.93939C4.07185 8.52517 4.07184 9.47492 4.65763 10.0607L5.76854 11.1716V12.7427C5.76854 13.5711 6.44012 14.2427 7.26854 14.2427H8.83961L9.95053 15.3536C10.5363 15.9394 11.4861 15.9394 12.0718 15.3536L13.1828 14.2427H14.7538C15.5823 14.2427 16.2538 13.5711 16.2538 12.7427V11.1716L17.3647 10.0607C17.9505 9.47492 17.9505 8.52517 17.3647 7.93939L16.2538 6.82847V5.25741C16.2538 4.42898 15.5823 3.75741 14.7538 3.75741H13.1828ZM12.6221 4.61096C12.7159 4.70473 12.843 4.75741 12.9757 4.75741H14.7538C15.03 4.75741 15.2538 4.98126 15.2538 5.25741V7.03558C15.2538 7.16819 15.3065 7.29537 15.4003 7.38913L16.6576 8.64649C16.8529 8.84176 16.8529 9.15834 16.6576 9.3536L15.4003 10.611C15.3065 10.7047 15.2538 10.8319 15.2538 10.9645V12.7427C15.2538 13.0188 15.03 13.2427 14.7538 13.2427H12.9757C12.843 13.2427 12.7159 13.2954 12.6221 13.3891L11.3647 14.6465C11.1695 14.8418 10.8529 14.8418 10.6576 14.6465L9.40027 13.3891C9.3065 13.2954 9.17933 13.2427 9.04672 13.2427H7.26854C6.9924 13.2427 6.76854 13.0188 6.76854 12.7427V10.9645C6.76854 10.8319 6.71587 10.7047 6.6221 10.611L5.36474 9.3536C5.16948 9.15834 5.16948 8.84176 5.36474 8.64649L6.6221 7.38913C6.71587 7.29537 6.76854 7.16819 6.76854 7.03558V5.25741C6.76854 4.98126 6.9924 4.75741 7.26854 4.75741H9.04672C9.17933 4.75741 9.3065 4.70473 9.40027 4.61096L10.6576 3.3536C10.8529 3.15834 11.1695 3.15834 11.3647 3.3536L12.6221 4.61096Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9756 4.75728C12.843 4.75728 12.7158 4.70461 12.6221 4.61084L11.3647 3.35348C11.1694 3.15822 10.8529 3.15822 10.6576 3.35348L9.40024 4.61084C9.30647 4.70461 9.1793 4.75728 9.04669 4.75728H7.26851C6.99237 4.75728 6.76851 4.98114 6.76851 5.25728V7.03546C6.76851 7.16807 6.71584 7.29524 6.62207 7.38901L5.36471 8.64637C5.16945 8.84163 5.16945 9.15822 5.36471 9.35348L6.62207 10.6108C6.71584 10.7046 6.76851 10.8318 6.76851 10.9644V12.7426C6.76851 13.0187 6.99237 13.2426 7.26851 13.2426H9.04669C9.1793 13.2426 9.30647 13.2952 9.40024 13.389L10.6576 14.6464C10.8529 14.8416 11.1694 14.8416 11.3647 14.6464L12.6221 13.389C12.7158 13.2952 12.843 13.2426 12.9756 13.2426H14.7538C15.0299 13.2426 15.2538 13.0187 15.2538 12.7426V10.9644C15.2538 10.8318 15.3065 10.7046 15.4002 10.6108L16.6576 9.35348C16.8529 9.15822 16.8529 8.84163 16.6576 8.64637L15.4002 7.38901C15.3065 7.29524 15.2538 7.16807 15.2538 7.03546V5.25728C15.2538 4.98114 15.0299 4.75728 14.7538 4.75728H12.9756Z",
    fill: "#35B9E9",
    style: {
      fill: "#35B9E9",
      fill: "color(display-p3 0.2094 0.7240 0.9122)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6981 7.68697L10.3445 11.0405L8.65764 9.35363L9.36475 8.64653L10.3445 9.62631L12.991 6.97986L13.6981 7.68697Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1298_209",
    x: -0.98877,
    y: -1,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 0 0.113725 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1298_209"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1298_209",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostStatus);
export default __webpack_public_path__ + "static/media/host-status.07e277b623064a50ede7658b7340ac45722bc4f1cc16357d3d5b20c411b547b2.svg";
export { ForwardRef as ReactComponent };